import { SetURLSearchParams } from 'react-router-dom';

export interface FilterParams {
  search?: string | null;
  page?: number | string | null;
  searchBy?: string | null;
  createdFrom?: string | null;
  createdTo?: string | null;
  orderType?: string[];
}

export function getFiltersFromURL(searchParams: URLSearchParams): FilterParams {
  return {
    search: searchParams.get('search') || null,
    searchBy: searchParams.get('searchBy') || null,
    createdFrom: searchParams.get('createdFrom') || null,
    createdTo: searchParams.get('createdTo') || null,
    orderType: searchParams
      .getAll('orderType')
      .flatMap((v) => v.split(','))
      .filter(Boolean),
    page: searchParams.get('page') || 1,
  };
}

export function updateURLWithFilters(
  setSearchParams: SetURLSearchParams,
  filters: Partial<FilterParams>,
  options = { resetPage: false },
) {
  setSearchParams((prev) => {
    const params = new URLSearchParams(prev);

    // Search
    if (filters.search) params.set('search', filters.search);
    else params.delete('search');
    if (filters.searchBy) params.set('searchBy', filters.searchBy);
    else params.delete('searchBy');

    // Filters
    if (filters.createdFrom && filters.createdTo) {
      params.set('createdFrom', filters.createdFrom);
      params.set('createdTo', filters.createdTo);
    } else {
      params.delete('createdFrom');
      params.delete('createdTo');
    }

    if (filters.orderType?.length) {
      params.set('orderType', filters.orderType.join(','));
    } else params.delete('orderType');

    // A carrier is never shown to a merchant (owner 2026-10-28), so an old
    // `carrier` param is dropped rather than applied as an invisible filter.
    params.delete('carrier');

    if (filters.page) params.set('page', filters.page.toString());

    return params;
  });
}
